import "./antd.css";
import "./App.scss";

// import "react-pdf/dist/Page/AnnotationLayer.css";
// import "react-pdf/dist/Page/TextLayer.css";
/* eslint-disable react/jsx-filename-extension */
import React from "react";

import Routes from "./Pages/Routes";

function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;
